import * as React from 'react';
import {useState, useEffect} from 'react';
import {render} from 'react-dom';
import App from './index/app';
import SignIn from './sign-in';
import {user} from '../lib/user';
import * as User from './lib/user';
import * as api from './api';

const css = require('./index.css').default;

function Root() {
    const [user, setUser] = useState<user | null>(User.load());
    const [dealers, setDealers] = useState<{id: string, name: string}[] | null>(null);
    const [targetDealer, setTargetDealer] = useState<string | null>(null);

    useEffect(() => {
        if (user) {
            api.dealer.queryByEmail(user.email)
            .then(dealerxs => api.dealer.get(['id', 'name', 'online'], dealerxs.map(d => d.id)))
            .then(dealers => {
                const res = dealers.filter(d => d.online);
                setDealers(res.map(i => ({
                    id: i.id,
                    name: i.name || '未命名',
                })));
                if (res.length === 1) {
                    setTargetDealer(res[0].id);
                }
            })
        } else {
            setDealers(null);
        }
    }, [JSON.stringify(user)]);

    if (user === null) {
        return <SignIn onSignIn={setUser}/>
    } else if (dealers === null) {
        return <div id={css.main}><Loading/></div>;
    } else {
        if (dealers.length === 0) {
            return (
            <div id={css.main}>
                <div>您的 gmail 帳號尚未與任何經銷帳號連結</div>
                <div>請聯絡金安會計部 06-258-5148 為您設定連結</div>
            </div>);
        } else {
            if (targetDealer === null) {
                return <div id={css.main}><DealerSelector dealers={dealers} onSelect={setTargetDealer}/></div>;
            } else {
                return <App dealer={targetDealer}/>
            }
        }
    }
}

function Loading() {
    return (
    <div id={css.loading}>
        <img src='imgs/loading.gif'/>
        <div>載入中</div>
    </div>);
}

function DealerSelector({dealers, onSelect}: {
    dealers: {id: string, name: string}[],
    onSelect: (id: string) => void,
}) {
    return (
    <div id={css.dealerSelector}>
        <div className='title'>請選擇要登入的帳號</div>
        <div className='list'>
            {(() => {
                return dealers.map(({id, name}) => {
                    return <div className='item' key={id} onClick={() => onSelect(id)}>{name}</div>;
                })
            })()}
        </div>
    </div>);
}

render(<Root/>, document.getElementById('root'));
